import EventEmitter from 'eventemitter3';
const eventEmitter = new EventEmitter();

export enum Events {
    PuzzleSolved = "PuzzleSolved"
}

export default eventEmitter;